import { render } from "./cheque.vue?vue&type=template&id=d85c362a&scoped=true"
import script from "./cheque.vue?vue&type=script&lang=js"
export * from "./cheque.vue?vue&type=script&lang=js"

import "./cheque.vue?vue&type=style&index=0&id=d85c362a&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d85c362a"]])

export default __exports__